<template>
  <div class="dragger"></div>
</template>

<script>
export default {
  props: {
    edge: {
      type: String,
      default: 'right'
    },
    width: {
      type: String,
      default: '3px'
    }
  },

  async mounted() {
    await this.$nextTick();
    let el = this.$el;
    el.style.borderWidth = this.width;
    let parentElm = el.parentElement;
    let parentDomRect = parentElm.getBoundingClientRect();
    this.parentOriginalWidth = parentDomRect.width;
    let htmlElm = document.querySelector('html');

    if (this.edge === 'right') {
      el.style.height = '100%';
      el.style.right = 0;
      // user-select: none
      interact(el).draggable({
        onstart: () => htmlElm.classList.add('user-select-none'),
        onend: () => htmlElm.classList.remove('user-select-none'),
        onmove: event => {
          let target = event.target;
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;

          // target.style.transform = 'translateX(' + x + 'px)';

          parentElm.style.width = this.parentOriginalWidth + x + 'px';
          // update the posiion attributes
          target.setAttribute('data-x', x);
        }
      });
    } else if (this.edge === 'left') {
      el.style.height = '100%';
      el.style.left = 0;

      interact(el).draggable({
        onstart: () => htmlElm.classList.add('user-select-none'),
        onend: () => htmlElm.classList.remove('user-select-none'),
        onmove: event => {
          let target = event.target;
          let x = (parseFloat(target.getAttribute('data-x')) || 0) - event.dx;

          // target.style.transform = 'translateX(' + -x + 'px)';

          parentElm.style.width = this.parentOriginalWidth + x + 'px';
          // update the posiion attributes
          target.setAttribute('data-x', x);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>

.dragger {
  position: absolute;
  cursor: col-resize;
  font-size: 1rem;
  opacity: 0;
  transition: 0.1s opacity;
  // height: 100%;
  border-style: solid;
  border-color: $accent-color;
  z-index: 1;

  &:hover, &:active {
    opacity: 1;
  }
}
</style>